export const STORAGE_KEYS = {
  INTERMEDIATE_SESSION_TOKEN: "intermediateSessionToken",
  CLIENT_ID: "clientId",
  THEME: "theme",
  REACT_QUERY_OFFLINE_CACHE: "REACT_QUERY_OFFLINE_CACHE",
  TIMEZONE: "timezone",
  TABLE_COLUMN_SETTINGS: "tableColumnSettings",
  TABLE_COLUMN_ORDER: "tableColumnOrder",
  TENANT_SCHEMA_NAME: "tenantSchemaName",
} as const;
